import { z } from 'zod';

export const ServiceCatalogItemSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, 'form.validation.nameRequired'),
    code: z.string().optional().or(z.literal('')),
    description: z.string().optional().or(z.literal('')),
    serviceType: z.enum(['business', 'technical', 'shared']).default('business'),
    status: z.enum(['active', 'retired']).default('active'),
    ownerName: z.string().optional().or(z.literal('')),
    ownerDisplayName: z.string().optional().or(z.literal('')),
    partyInstanceId: z.string().optional(),
    problemCorrelationKey: z.string().optional().or(z.literal('')),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateServiceCatalogItemSchema = ServiceCatalogItemSchema.omit({ id: true });
export const UpdateServiceCatalogItemSchema = CreateServiceCatalogItemSchema.partial();
